﻿(function (DealPage) {

    var dealCostCalculator = function (financeType, depositMonths, term, additionalFees) {
        var calculate = function (priceExcludingVat, priceIncludingVat) {
            var price = financeType === "Personal" ? priceIncludingVat : priceExcludingVat;
            var monthlyPrice = price / (depositMonths + term);

            return {
                monthlyPrice: Number(monthlyPrice.toFixed(2)),
                totalPrice: Number(price.toFixed(2))
            };
        };

        var calculateInitialPayment = function (monthlyPrice) {
            return ((depositMonths * monthlyPrice) + additionalFees).toFixed(2);
        };

        return {
            calculate: calculate,
            calculateInitialPayment: calculateInitialPayment
        };
    };

    DealPage.DealCostCalculator = dealCostCalculator;

})(DealPage || (DealPage = {}));